<template>
  <v-container grid-list-md >
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion mb-2 pb-3" style="border-bottom: 1px solid #D3D4D8;">Responda correctamente después de leer el siguiente texto. </p>
      </div>
      <div class="e-ejercicio-ejercicio ejercicio-calendario pt-0">
        <v-layout  pt-0 column>
          <h3 class="e-sub-sub-title-md text-xs-left py-3 black-text">Julio</h3>
          <CardCalendario v-for="calendario in calendario"
          :key="calendario.id"
          :numero="calendario.numero"
          :diaKr="calendario.diaKr"
          :diaEn="calendario.diaEn" />
          <v-flex>
            <v-btn
            block
            round
            large
            router-link
            :to="`/practica/intermedio/${idUnidad}/ejercicio/practicaPregunta`"
            class="elevation-0"
            color="primary">
              CONTINUAR
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CardCalendario from '../../../components/Practica/intermedio/CardCalendario'

export default {
  name: 'PracticaCalendario',
  props: ['idUnidad'],
  data () {
    return {
      calendario: [
        {
          id: 0,
          numero: 16,
          diaKr: '안녕하세요',
          diaEn: 'Wednesday'
        },
        {
          id: 1,
          numero: 17,
          diaKr: '안녕하세요',
          diaEn: 'Wednesday'
        },
        {
          id: 2,
          numero: 18,
          diaKr: '안녕하세요',
          diaEn: 'Wednesday'
        },
        {
          id: 3,
          numero: 19,
          diaKr: '안녕하세요',
          diaEn: 'Wednesday'
        }
      ]
    }
  },
  components: {
    CardCalendario
  },
  computed: {
    ...mapState({
      ui: state => state.ui
    })
  },
  methods: {
    ...mapActions('ui', [
      'texto'
    ])
  }
}
</script>
